window.DataParser = window.DataParser ?? {};
window.DataParser.CartItem = function(data){
  const result= {
    variant_id: data.variant_id,
    variant_title: data.untranslated_variant_title,
    product_id: data.product_id,
    product_title: data.untranslated_product_title,
    sku: data.sku,
    price: data.original_price / 100,
    final_price: data.final_price / 100,
    quantity: data.quantity,
    vendor: data.vendor
  }
  return result;
};
document.addEventListener("alpine:init", () => {
  Alpine.store("events", {
    debug: false,
    delayQueue: [],
    contextInited:false,
    pushEvent(evt) {
      if(this.contextInited == false){
        this.delayQueue.push(evt);
        return;
      }
      if (this.debug) {
        window.dataLayer.push(evt);
      } else {
        window.Shopify.analytics.publish("madax_event", evt);
      }
    },
    init_context(context_data){
      this.contextInited = true;
      this.pushEvent({
        event: 'madax_info',
        ...context_data
      })
      this.delayQueue.forEach(evt=>{
        this.pushEvent(evt);
      })
    },
    view_item(elm){
      const dataEle = elm.querySelector('[product-json-data]');
      const jsonData = JSON.parse(dataEle.innerText);
      const productData = {
        ...jsonData.data,
        ...jsonData.metafields,
      };
      pushEvent({
        event: 'madax_view_item',
        active_product: productData,
      })
    },
    view_item_list(elm, list_id, list_name){
      const dataEles = elm.querySelectorAll('[product-json-data]');
      const listProducts = [];
      dataEles.forEach(dataEle => {
        const jsonData = JSON.parse(dataEle.innerText);
        listProducts.push({
          ...jsonData.data,
          ...jsonData.metafields,
        });
      });
      this.pushEvent({
        event: 'madax_view_item_list',
        list_products: listProducts,
        list_id: list_id,
        list_name: list_name,
      })
    },
    init(){
        window.document.body.addEventListener('baseline:cart:afteradditem', (event) => {
          const cartItem = window.DataParser.CartItem(event.detail.response);
          this.pushEvent({
            event: 'madax_add_to_cart',
            cart_item_data: cartItem,
          });
        });
    }
  });
});
